import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { PagePropsContext } from '../App';
import Header from '../components/Header';
import ContactForm from '../components/ContactForm';
import { isDesktop } from '../utils/functions';
import { useOnClickOutside } from '../utils/hooks';

const PageContact = () => {
  const { t } = useTranslation();
  const { setShowContact } = useContext(PagePropsContext);
  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    isDesktop() && setShowContact(false);
  });

  return (
    <div className='page page--contact'>
      <Header
        title={t('help.title')}
        showBreadcrumb={true}
        onBack={() => setShowContact(false)}
      />
      <div className='page__content' ref={ref}>
        <div className='page__title'>{t('help.title')}</div>
        <ContactForm />
      </div>
    </div>
  );
};

export default PageContact;